import { render, staticRenderFns } from "./DetalleNivelActual.vue?vue&type=template&id=74a38f10&"
import script from "./DetalleNivelActual.vue?vue&type=script&lang=js&"
export * from "./DetalleNivelActual.vue?vue&type=script&lang=js&"
import style0 from "./DetalleNivelActual.vue?vue&type=style&index=0&id=74a38f10&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports